// extracted by mini-css-extract-plugin
module.exports = {"paginate":"Paginated_paginate__2epIG","prev":"Paginated_prev__TfYDo"};